<template>
  <div style="height: 100%">
    <sys-menu ref="sysMenu"></sys-menu>
    <center id="center">
      <top v-on:child-say="listenMore" ref="top"></top>
      <!-- <router-view
      ></router-view> -->
      <template v-if="loadEnd">
        <keep-alive
          ><router-view v-if="$route.meta.keepAlive"> </router-view
        ></keep-alive>
        <router-view v-if="!$route.meta.keepAlive"> </router-view>
      </template>

      <!-- https://segmentfault.com/a/1190000022829758 -->
      <!-- inlcude包含该组件就缓存，exclude不包含该组件就缓存，二者都可以用逗号分隔字符串、正则表达式或一个数组来表示 -->
    </center>
  </div>
</template>
<script>
import sysMenu from "../../node_modules/common/src/components/sys/sysMenu.vue";
import top from "../../node_modules/common/src/components/sys/top.vue";

export default {
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      loadEnd: false,
    };
  },
  components: {
    sysMenu,
    top,
  },
  methods: {
    listenMore(t) {
      this.more = t;
    },
    reload() {
      this.isShow = false;
      this.$nextTick(function () {
        this.isShow = true;
      });
    },

    getProperty() {
      //this.loadEnd = false;
      this.axios({
        method: "post",
        url: this.axios.oss + "/property/select",
        data: {},
      }).then((res) => {
        var data = res.data.data;
        this.axios.mapConfig = data.customProperty;
        //axios.platConfig.mapRefresh
        //sessionStorage.setItem(axios.plat + "123", JSON.stringify(data));
        this.axios.platConfig = data.publicProperty;
        //this.loadEnd = true;
        this.getdictionary();
        this.$refs.sysMenu.getMenu();
        this.$refs.top.reachData();
      });
    },
    getdictionary() {
      this.loadEnd = false;
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-common-server-dm/dictionary/list",
        data: {},
      }).then((res) => {
        this.loadEnd = true;
        if (res) {
          var data = res.data.data.dataList;
          for (let i = 0; i < data.length; i++) {
            this.lydic[data[i].keyword] = JSON.parse(data[i].value);
          }
        } else {
          this.$Message.error("字典加载失败");
        }
      });
    },
  },
  created() {
    this.getProperty();
    //this.getdictionary();
  },
  destroyed() {
    //websock.close(); //离开路由之后断开websocket连接
    //this.alarms = [];
  },
};
</script>
<style lang="">
#reLink {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 2222;
  background: rgba(0, 0, 0, 0.3);
}
#reLinkson {
  margin: 100px auto;
  width: 300px;
  background: #fff;
  padding: 20px;
}
#reLinkson h2 {
  font-size: 18px;
  margin-bottom: 10px;
}
#reLinkson p {
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue